module.exports = __webpack_public_path__ + "img/base_activites_kite_surf.ffeb621c.svg";